export const environment = {
    production: false,
    enableConsoleLogs: false,
    identityUrl: 'https://identity-v2-staging.nside.io',
    nSidePlatformUrl: 'https://staging.nside.io/',
    withCredentials: true,
    angularAppUrl: 'https://nside-eop-staging.nside.io',
    apiBaseUrl: 'https://rems-eop-api-staging.nside.io'
};
